import { currentUser, updateSingleUser } from "../services/userService"

function getQueryStringValue (key) {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key) + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

export const getCurrentUser = () => dispatch => {
    let userId = getQueryStringValue('user');
    currentUser(userId).then(function (response) {
            // handle success
        dispatch( {
                type: 'GET_CURRENT_USER',
                payload: response
            });
        })
        .catch(function (error) {
            // handle error
            dispatch({
                type: 'GET_CURRENT_USER',
                payload: []
            });
        })

};

export const userUpdate = (id, data, cb) => dispatch => {
    updateSingleUser(id, data).then((userData) => {
        dispatch( {
                type: 'USER_UPDATE',
                payload: userData
            });
            if(typeof cb === 'function') {
                cb();
            }
        })
        .catch((error) => {
            // handle error
            dispatch({
                type: 'USER_UPDATE',
                payload: []
            });
        })
};